export default "__VITE_ASSET__DvkAE4Ac__"